import script from "./sf-dropdown-wrapper.ce.vue?vue&type=script&lang=ts&setup=true"
export * from "./sf-dropdown-wrapper.ce.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__